import React from 'react';

export function TransactionFilters({ activeFilter, onFilterChange }) {
  const filters = [
    { value: 'all', label: 'All' },
    { value: 'income', label: 'Income' },
    { value: 'expenses', label: 'Expenses' },
    { value: 'tax-deductible', label: 'Tax-Deductible' },
    { value: 'invoices', label: 'Invoices' },
  ];

  return (
    <div className="flex gap-2 overflow-x-auto pb-2">
      {filters.map((f) => (
        <button
          key={f.value}
          onClick={() => onFilterChange(f.value)}
          className={`px-4 py-2 rounded-lg font-medium text-sm whitespace-nowrap transition-colors ${
            activeFilter === f.value
              ? 'bg-primary text-background'
              : 'bg-surface text-text-secondary hover:text-foreground hover:bg-surface-raised border border-border'
          }`}
          data-testid={`filter-${f.value}`}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
